import { useMutation } from "react-query";
import statusService from "../services/statusService";

const useStatusHistoryQueries = (onData) => {
  return useMutation(statusService.getStatusHistory, {
    onSuccess: (data) => onData(data),
  });
};

const useTodayWorkStatusCreate = (onData) => {
  return useMutation(statusService.todayWorkStatusCreate, {
      onSuccess: (data) => {
          onData(data);
      },
  });
};

const statusQueries = {
  useStatusHistoryQueries,
  useTodayWorkStatusCreate
};

export default statusQueries;
